import { useRef, useState } from "react";
import { Upload, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { uploadFileChunked } from "./uploadFile";

export const UploadField = ({ label, accept, token, value, onUploaded, testId, hint }) => {
  const inputRef = useRef(null);
  const [progress, setProgress] = useState(null);

  const handleChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setProgress(0);
    try {
      const result = await uploadFileChunked(file, token, setProgress);
      onUploaded(result);
      toast.success(`${file.name} uploaded`);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Upload failed");
    } finally {
      setProgress(null);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const uploading = progress !== null;

  return (
    <div>
      <Label className="font-sub text-[10px] text-white/40 tracking-widest mb-2 block">{label}</Label>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handleChange} data-testid={`${testId}-input`} />
      <button
        type="button"
        data-testid={`${testId}-btn`}
        disabled={uploading}
        onClick={() => inputRef.current?.click()}
        className="w-full border border-dashed border-white/20 hover:border-white/50 py-5 px-4 flex items-center justify-center gap-3 transition-colors duration-300 disabled:opacity-60"
      >
        {uploading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin text-white/60" />
            <span className="font-sub text-xs text-white/60 tracking-widest">UPLOADING {progress}%</span>
          </>
        ) : value ? (
          <>
            <Check className="w-4 h-4 text-white/70" />
            <span className="font-sub text-xs text-white/70 tracking-wide truncate max-w-xs">{value}</span>
          </>
        ) : (
          <>
            <Upload className="w-4 h-4 text-white/40" />
            <span className="font-sub text-xs text-white/40 tracking-widest">CHOOSE FILE</span>
          </>
        )}
      </button>
      {uploading && (
        <div className="h-px bg-white/10 mt-2">
          <div className="h-px bg-white transition-all duration-300" style={{ width: `${progress}%` }} />
        </div>
      )}
      {hint && <p className="font-sub text-[10px] text-white/30 mt-2 tracking-wide">{hint}</p>}
    </div>
  );
};
